import React from 'react';
import styles from './TeaPrepare.module.scss';


export default function TeaPrepare() {
  return (
    <section id='prepare' className={styles.teaPrepare}>
      <div className="container">
        <div className={styles.container}>
          <h6 className={styles.title}>Как готовить?</h6>
          <p className={styles.text}>Разнообразный и богатый опыт новая модель организационной деятельности позволяет оценить значение позиций, занимаемых участниками в отношении поставленных задач. Значимость этих проблем настолько очевидна, что дальнейшее развитие различных форм деятельности в значительной степени обуславливает создание модели развития ленных задач. Значимость этих проблем настолько очевидна, что дальнейшее развитие различных форм деятельности в значительной степени обуславливает создание модели развития</p>
        </div>
      </div>
    </section>
  );
}



